const TYPES = {
    CATEGORY: 'category',
    SUB_CATEGORY: 'sub_category',
    NESTED_SUB_CATEGORY: 'nested_sub_category',
    CMS: 'CMS',
    SEARCH_QUERY: 'search_query',
    STATIC_PAGE: 'static_page',
    FILTERED_PAGE: 'filtered_page',
    PLACEHOLDER: 'placeholder',
    MENU_PANEL: 'menu_panel'
};

const PATHS = {
    ROOT: '#!',
    HOMEPAGE: '/'
};

const CATEGORIES_MAPPER = {
    'graphics': 'graphics-design',
    'social-marketing': 'online-marketing',
    'writing': 'writing-translation',
    'video': 'video-animation',
    'music': 'music-audio',
    'programming': 'programming-tech',
    'technology': 'programming-tech',
    'tips-advice': 'lifestyle',
    'other': 'lifestyle',
    'fun-bizarre': 'lifestyle',
    'gifts': 'lifestyle',
    'advertising': 'online-marketing',
    'digital-marketing': 'online-marketing',
    'fun-and-lifestyle': 'lifestyle'
};

const CATEGORIES_ID_MAPPER = {
    'graphics-design': 3,
    'online-marketing': 2,
    'writing-translation': 5,
    'video-animation': 20,
    'music-audio': 12,
    'programming-tech': 10,
    'lifestyle': 7
};

const EVENTS_MAPPING = {
    PAGE_VIEWED: {
        mixpanel: 'Viewed page'
    },
    PAGE_CHANGE: {
        mixpanel: 'Paginate'
    },
    CLICK: {
        mixpanel: 'Clicked',
        TARGETS: {
            HOW_FIVERR_WORKS_VIDEO: 'How Fiverr Works Video In Category'
        }
    }
};

const BI_CONSTS = {
    mixpanel: {
        pageName: 'Category'
    },
    bigQuery: {
        pageName: 'category'
    }
};

module.exports = {
    TYPES,
    PATHS,
    CATEGORIES_MAPPER,
    CATEGORIES_ID_MAPPER,
    EVENTS_MAPPING,
    BI_CONSTS
};
